import NotFoundContent from "./content.vue";
import metaInfo from "./meta";

export default {
	name: "NotFoundPage",
	components: {
		NotFoundContent,
	},
	metaInfo,
};
